import router from '@/router'

export function routeManagerPlugin (store) {
  store.subscribe(function (mutation) {
    switch (mutation.type) {
      case 'management/usersList/createUserForm/CREATE_USER_COMPLETED':
        router.push({
          name: 'UserList',
          params: {
            isShowCreateUserAlert: true
          }
        })
        break
      case 'client/GET_ACCESS_TOKEN_COMPLETED':
        if (mutation.payload.refreshPage) {
          if (mutation.payload.logout) {
            router.push({
              name: 'SignIn',
              params: {
                isShowLogoutAlert: true
              }
            })
          } else {
            router.push({
              name: 'Home'
            })
          }
        }
        break
    }
  })
}
